import React from "react";
import { Text } from "@twilio-paste/core";

export type SnippetProps = {
  text?: string | null;
};

export const Snippet: React.FC<SnippetProps> = ({ text }) =>
  text ? (
    <Text
      as="p"
      color="colorTextWeak"
      fontSize="fontSize30"
      marginTop="space20"
      overflow="hidden"
      whiteSpace="nowrap"
    >
      {text}
    </Text>
  ) : null;
